import { defineMessages } from "react-intl";

export const messages = defineMessages({
  step01: {
    id: "guides.jasperBulkEdit.tour.step01",
    defaultMessage: "Bulk edit records on the Map",
    description: "Jasper Bulk Edit tour, step 1 (intro) title",
  },
  step01Description: {
    id: "guides.jasperBulkEdit.tour.step01.description",
    defaultMessage:
      "For today’s example, we’re going to move some of our records out of T Group 200 into a different T Group.",
    description: "Jasper Bulk Edit tour, step 1 (intro) message",
  },
  step02: {
    id: "guides.jasperBulkEdit.tour.step02",
    defaultMessage: "Filters",
    description: "Jasper Bulk Edit tour, step 2 (open filter) title",
  },
  step02Description: {
    id: "guides.jasperBulkEdit.tour.step02.description",
    defaultMessage: "Open Filter in the top left — we’re going to filter by T Group.",
    description: "Jasper Bulk Edit tour, step 2 (open filter) message",
  },
  step03: {
    id: "guides.jasperBulkEdit.tour.step03",
    defaultMessage: "Company filters",
    description: "Jasper Bulk Edit tour, step 3 (choose filter type) title",
  },
  step03Description: {
    id: "guides.jasperBulkEdit.tour.step03.description",
    defaultMessage: "Click “Company” to add a company filter.",
    description: "Jasper Bulk Edit tour, step 3 (choose filter type) message",
  },
  step04: {
    id: "guides.jasperBulkEdit.tour.step04",
    defaultMessage: "Select a field",
    description: "Jasper Bulk Edit tour, step 4 (select filter field) title",
  },
  step04Description: {
    id: "guides.jasperBulkEdit.tour.step04.description",
    defaultMessage: "Select the “T Group” field.",
    description: "Jasper Bulk Edit tour, step 4 (select filter field) message",
  },
  step05: {
    id: "guides.jasperBulkEdit.tour.step05",
    defaultMessage: "Filter value",
    description: "Jasper Bulk Edit tour, step 5 (filter value) title",
  },
  step05Description: {
    id: "guides.jasperBulkEdit.tour.step05.description",
    defaultMessage:
      "We’ve set the value to 200 — type a different T Group if you like, then click anywhere on the map to continue.",
    description: "Jasper Bulk Edit tour, step 5 (filter value) message",
  },
  step06: {
    id: "guides.jasperBulkEdit.tour.step06",
    defaultMessage: "Lasso Tool",
    description: "Jasper Bulk Edit tour, step 6 (lasso tool button) title",
  },
  step06Description: {
    id: "guides.jasperBulkEdit.tour.step06.description",
    defaultMessage: "Select the Lasso tool.",
    description: "Jasper Bulk Edit tour, step 6 (lasso tool button) message",
  },
  step07: {
    id: "guides.jasperBulkEdit.tour.step07",
    defaultMessage: "Lasso Tool",
    description: "Jasper Bulk Edit tour, step 7 (draw lasso) title",
  },
  step07Description: {
    id: "guides.jasperBulkEdit.tour.step07.description",
    defaultMessage: "Now draw a lasso around the pins you want to move, and we’ll proceed.",
    description: "Jasper Bulk Edit tour, step 7 (draw lasso) message",
  },
  step07DescriptionA: {
    id: "guides.jasperBulkEdit.tour.step07A.description",
    defaultMessage: "",
    description: "Jasper Bulk Edit tour, step 7 (draw lasso) message",
  },
  step08: {
    id: "guides.jasperBulkEdit.tour.step08",
    defaultMessage: "Your selection",
    description: "Jasper Bulk Edit tour, step 8 (selection count) title",
  },
  step08Description: {
    id: "guides.jasperBulkEdit.tour.step08.description",
    defaultMessage: "Here you can see how many pins you’ve selected.",
    description: "Jasper Bulk Edit tour, step 8 (selection count) message",
  },
  step09: {
    id: "guides.jasperBulkEdit.tour.step09",
    defaultMessage: "Bulk Edit",
    description: "Jasper Bulk Edit tour, step 9 (bulk edit button) title",
  },
  step09Description: {
    id: "guides.jasperBulkEdit.tour.step09.description",
    defaultMessage: "Select Bulk Edit to update all selected records at once.",
    description: "Jasper Bulk Edit tour, step 9 (bulk edit button) message",
  },
  step10: {
    id: "guides.jasperBulkEdit.tour.step10",
    defaultMessage: "Bulk Edit",
    description: "Jasper Bulk Edit tour, step 10 (bulk edit field) title",
  },
  step10Description: {
    id: "guides.jasperBulkEdit.tour.step10.description",
    defaultMessage: "Select the “T Group” field.",
    description: "Jasper Bulk Edit tour, step 10 (bulk edit field) message",
  },
  step11: {
    id: "guides.jasperBulkEdit.tour.step11",
    defaultMessage: "New value",
    description: "Jasper Bulk Edit tour, step 11 (bulk edit value) title",
  },
  step11Description: {
    id: "guides.jasperBulkEdit.tour.step11.description",
    defaultMessage: "Enter the T Group you want to move these records to.",
    description: "Jasper Bulk Edit tour, step 11 (bulk edit value) message",
  },
  step12: {
    id: "guides.jasperBulkEdit.tour.step12",
    defaultMessage: "Apply",
    description: "Jasper Bulk Edit tour, step 12 (apply) title",
  },
  step12Description: {
    id: "guides.jasperBulkEdit.tour.step12.description",
    defaultMessage:
      "Now, if you click “Apply”, the records’ T Group will be updated. Or click “Done” to finish this tour without updating the records.",
    description: "Jasper Bulk Edit tour, step 12 (apply) message",
  },
});

export const errorMessages = defineMessages({
  noTGroupField: {
    id: "guides.jasperBulkEdit.tour.error.noTGroupField",
    defaultMessage:
      "This tour requires a company field named “T Group”, but your organization doesn’t have one.",
    description: "Jasper Bulk Edit tour, error shown when the T Group company field is missing",
  },
});
